(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.lp-guides').forEach((details) => {
    let timer;
    details.addEventListener('pointerenter', (event) => { if (event.pointerType === 'touch') return; clearTimeout(timer); details.open = true; });
    details.addEventListener('pointerleave', () => { timer = setTimeout(() => { if (!details.matches(':hover') && !details.contains(document.activeElement)) details.open = false; }, 350); });
    details.addEventListener('keydown', (event) => { if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); } });
    details.addEventListener('focusout', () => { setTimeout(() => { if (!details.contains(document.activeElement) && !details.matches(':hover')) details.open = false; }, 0); });
    document.addEventListener('pointerdown', (event) => { if (!details.contains(event.target)) details.open = false; });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rss-chassis-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    const group = event.target;
    if (!(group instanceof HTMLDetailsElement) || !group.classList.contains('rss-chassis-menu__group')) return;
    requestAnimationFrame(() => {
      const menu = group.closest('header-menu');
      const header = group.closest('header-component');
      const submenu = group.closest('.menu-list__submenu');
      if (!menu || !header || !submenu || menu.getAttribute('aria-expanded') !== 'true') return;
      let height = submenu.offsetHeight;
      const item = submenu.closest('.menu-list__list-item');
      if (item?.slot === 'overflow') {
        const overflow = menu.querySelector('overflow-list')?.shadowRoot?.querySelector('[part="overflow"]');
        height = Math.max(height, overflow?.offsetHeight || 0);
      }
      const visibleHeader = header.hasAttribute('data-submenu-overlap-bottom-row')
        ? header.querySelector('.header__row--top')?.offsetHeight || header.offsetHeight
        : header.offsetHeight;
      header.style.setProperty('--submenu-height', height + 'px');
      header.style.setProperty('--full-open-header-height', (height + visibleHeader) + 'px');
    });
  }, true);
  } catch(e) { console.error(e); }
})();

})();
